import { render } from "./CreateClient.vue?vue&type=template&id=448db9c9"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"
script.render = render

export default script